import { render, staticRenderFns } from "./ProjectTableContactDoctor.vue?vue&type=template&id=7250a566&"
import script from "./ProjectTableContactDoctor.vue?vue&type=script&lang=js&"
export * from "./ProjectTableContactDoctor.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTableContactDoctor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports